export default {
  title: 'Añadir tarjeta de crédito',
  buttons: {
    save: 'Guardar',
  },
  feedback: {
    success: 'Tarjeta añadida correctamente',
  },
};
